import React from 'react';
import styled from 'styled-components';
import { Route, NavLink, Switch } from 'react-router-dom';

import { Flex, Box } from 'grid-styled';
import session from '../session';

import Network from './Network';
import Status from './Status';
import Home from './Home';
import Syslog from './Syslog';
import Stream from './Stream';
import Error from './Error';
import Relay from './Relay';
import IcecastLogs from './IcecastLogs';
import { HR } from '../uic/HorizontalLine';

import { BoxTemplate } from '../styledSystem/Box';
import { Header2, Label } from '../styledSystem/Text';

const Link = styled(NavLink).attrs({
    activeClassName: 'active'
})`
    display: inline-block;
    margin: 5px;
    padding: 5px;
    text-decoration: none;
    font-family: sans-serif;
    color: rgb(40, 40, 45);
    font-weight: bold;
    fontsize: 12px;

    &:hover {
        background-color: lightgray;
    }

    &.active {
        border-bottom: 2px solid #ee0606;
    }

    float: ${props => (props.logout ? 'right' : 'inherit')};
    border: ${props => (props.logout ? '1px solid #DBDBDB' : 'inherit')};
    border-radius: ${props => (props.logout ? '5px' : 'inherit')};
`;

export default class Internal extends React.Component {
    state = {
        macaddress: '',
        fwversion: ''
    };

    async componentWillMount() {
        try {
            const settingsMac = await session.rpc('call', [
                '',
                'barix_webui',
                'status_get_by_name',
                { name: 'mac_lan' }
            ]);

            const settingsVersion = await session.rpc('call', [
                '',
                'version',
                'get',
                {}
            ]);

            if (settingsMac === 500 || settingsVersion === 500) {
            } else {
                this.setState({
                    macaddress: settingsMac[1].mac_lan,
                    fwversion: settingsVersion[1].versions.firmware
                });
            }
        } catch (err) {
            console.error('get mac and fw versions:' + err);
        }
    }

    render() {
        return (
            <Box>
                <Box>
                    <Box>
                        <BoxTemplate w={[1, 3 / 4]} display="inline-block">
                            <Box mt={'15px'} mr={'20px'}>
                                <img
                                    src={require('../assets/Barix_Logo.png')}
                                    alt="Barix_logo"
                                    width="200"
                                />
                            </Box>
                        </BoxTemplate>
                        <BoxTemplate
                            textalign="right"
                            display="inline-block"
                            w={[1, 1 / 4]}
                        >
                            <Header2>Instreamer ICE</Header2>
                            <BoxTemplate display="inline-block">
                                <Label textStyle="labelBold">MAC:</Label>
                            </BoxTemplate>
                            <BoxTemplate display="inline-block">
                                <Label textStyle="labelNormal">
                                    {this.state.macaddress}
                                </Label>
                            </BoxTemplate>
                            <BoxTemplate display="inline-block">
                                <Label textStyle="labelBold"> FW:</Label>
                            </BoxTemplate>
                            <BoxTemplate display="inline-block">
                                <Label textStyle="labelNormal">
                                    {this.state.fwversion}
                                </Label>
                            </BoxTemplate>
                        </BoxTemplate>
                    </Box>
                    <Flex>
                        <Link to="/home">Home</Link>
                        <Link to="/network">Network</Link>
                        <Link to="/status">Status</Link>
                        <Link to="/stream">Stream</Link>

                        {session.user === 'admin' && (
                            <React.Fragment>
                                <Link to="/relay">Relay</Link>
                                <Link to="/icecast-logs">Icecast-Logs</Link>
                                <Link to="/syslog">Syslog</Link>
                            </React.Fragment>
                        )}
                        <Box flex="1" />

                        <Link to="/login" onClick={() => session.logout()}>
                            Log out
                        </Link>
                    </Flex>
                </Box>
                <Box>
                    <HR height="9px" />
                </Box>
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route path="/home" component={Home} />
                    <Route path="/network" component={Network} />
                    <Route path="/status" component={Status} />
                    <Route path="/stream" component={Stream} />

                    {session.user === 'admin' && (
                        <React.Fragment>
                            <Route path="/relay" component={Relay} />
                            <Route
                                path="/icecast-logs"
                                component={IcecastLogs}
                            />
                            <Route path="/syslog" component={Syslog} />
                        </React.Fragment>
                    )}
                    <Route component={Error} />
                </Switch>
            </Box>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Internal.js